import axios from "axios";
import queryString from "query-string";

const Company = {
  getCompany: async (id = null) => {
    const args = id === null ? "" : `?id=${id}`;
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/enterprise${args}`,
    );
    return response;
  },
  getCompanies: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/enterprise?${queryString.stringify(data)}`,
    );
    return response;
  },
  saveCompany: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/enterprise`,
      data,
    );
    return response;
  },
  updateCompany: async (data) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/enterprise`,
      data,
    );
    return response;
  },
  deleteCompany: async (id = null) => {
    const args = id === null ? "" : `?id=${id}`;
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + `/eira/enterprise${args}`,
    );
    return response;
  },
  createSubscription: async (data, enterprise) => {
    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("modules", JSON.stringify(data.modules));
    formData.append("sensitive_data", data.sensitive_data);
    formData.append("enterprise_id", enterprise);
    if (data.image !== "") {
      formData.append("image", data.image);
    }

    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/subscription`,
      formData,
    );
    return response;
  },
  updateSubscription: async (data, enterprise) => {
    let formData = new FormData();
    formData.append("subscription_id", data.subscription_id);
    formData.append("enterprise_id", enterprise);
    formData.append("name", data.name);
    formData.append("modules", JSON.stringify(data.modules));
    formData.append("submodules", JSON.stringify(data.submodules));
    formData.append("sensitive_data", data.sensitive_data);
    formData.append("access_code", data.access_code);
    formData.append("duration_days", data.duration_days);
    if (data.image !== "" && data.image !== undefined) {
      formData.append("image", data.image);
    }

    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/subscription`,
      formData,
    );
    return response;
  },
  updateSubscriptionCategories: async (data) => {
    let formData = new FormData();
    formData.append("subscription_id", data.subscription_id);
    formData.append("enterprise_id", data.enterprise_id);
    formData.append("categories", JSON.stringify(data.categories));

    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/subscription`,
      formData,
    );
    return response;
  },
  setInitialProtocolSubscription: async (data) => {
    let formData = new FormData();
    formData.append("subscription_id", data.subscription_id);
    formData.append("enterprise_id", data.enterprise_id);
    formData.append("modules", JSON.stringify(data.modules));
    formData.append("initial_protocol", data.initial_protocol);

    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/subscription`,
      formData,
    );
    return response;
  },
  getSubscriptions: async (enterprise_id) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/subscription?enterprise_id=${enterprise_id}`,
    );
    return response;
  },
  companyEnrolledUser: async (enterprise_id, data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/invite?enterprise_id=${enterprise_id}&rol=eira-patient&param=user&${queryString.stringify(
          data,
        )}`,
    );
    return response;
  },
  getmodules: async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/module`,
    );
    return response;
  },
  asociateProtocol: async (data) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/protocol`,
      data,
    );
    return response;
  },
  saveExternalLink: async (data) => {
    console.log("saveExternalLink", data);
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/external-link`,
      {
        ...(data.id ? { external_link_id: data.id } : null),
        label: data.label,
        description: data.description,
        url: data.url,
        subscriptions: data.subscriptions, // array
        enterprise: data.enterprise, // needed if subscriptions=[]|""|null.
      },
    );
    return response;
  },
  getExternalLink: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/external-link`,
      {
        enterprise: data.enterprise,
        subscription: data.subscription,
      },
    );
    return response;
  },
  getStaff: async (enterprise, rol) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/staff?enterprise=${enterprise}&rol=${rol}`,
    );
    return response;
  },
  updateStaff: async (data) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/service/staff`,
      {
        username: data.username,
        rol: data.rol,
        subscriptions: data.subscriptions,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return response;
  },
  getAllVademecum: async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/vademecum`,
    );
    return response;
  },
  getProtocolCompanies: async (id) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/protocol/enterprises?id=${id}`,
    );
    return response;
  },
};

export default Company;
